/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteUserResponse } from '../models/DeleteUserResponse';
import type { GetUserResponse } from '../models/GetUserResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UserService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * ccs user id -> puid
   * ccs user id -> puid
   * @returns string OK
   * @throws ApiError
   */
  public getPuidViaIdpConnector({
    userId,
  }: {
    userId: string,
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/ccs/puid/{userId}',
      path: {
        'userId': userId,
      },
    });
  }
  /**
   * @returns GetUserResponse OK
   * @throws ApiError
   */
  public getUser({
    userId,
  }: {
    userId: string,
  }): CancelablePromise<GetUserResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/hmg-privacy/users/{userId}',
      path: {
        'userId': userId,
      },
    });
  }
  /**
   * @returns DeleteUserResponse OK
   * @throws ApiError
   */
  public deleteUser({
    userId,
  }: {
    userId: string,
  }): CancelablePromise<DeleteUserResponse> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/hmg-privacy/users/{userId}',
      path: {
        'userId': userId,
      },
    });
  }
  /**
   * @returns GetUserResponse OK
   * @throws ApiError
   */
  public getUser1({
    userId,
  }: {
    userId: string,
  }): CancelablePromise<GetUserResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/hmg-privacy/users/{userId}/',
      path: {
        'userId': userId,
      },
    });
  }
  /**
   * @returns DeleteUserResponse OK
   * @throws ApiError
   */
  public deleteUser1({
    userId,
  }: {
    userId: string,
  }): CancelablePromise<DeleteUserResponse> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/hmg-privacy/users/{userId}/',
      path: {
        'userId': userId,
      },
    });
  }
  /**
   * @returns string OK
   * @throws ApiError
   */
  public getUser2({
    userId,
  }: {
    userId: string,
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/common/users/ccs/{userId}/',
      path: {
        'userId': userId,
      },
    });
  }
  /**
   * @returns string OK
   * @throws ApiError
   */
  public getUser3({
    userId,
  }: {
    userId: string,
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/common/users/ccs/{userId}',
      path: {
        'userId': userId,
      },
    });
  }
}
